var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPersonCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27.25,
    stroke: "#000064",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 40.43s.689-3.735 4.98-4.565c4.291-.83 4.556-1.867 4.556-2.698V32.13a7.33 7.33 0 01-2.119-3.631c-1.324 0-2.12-1.556-2.12-3.113 0-.415 0-2.075 1.06-2.075-.847-3.32-.211-6.744 2.12-6.744 5.51-3.63 13.244-.778 10.595 6.744 1.06 0 1.06 1.66 1.06 2.075 0 1.556-.795 3.113-2.12 3.113a7.28 7.28 0 01-2.118 3.631v1.037c0 .83.265 1.868 4.556 2.698 4.98.986 4.98 4.565 4.98 4.565",
    stroke: "#000064",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgIconPersonCircle;